import { Action } from '@ngrx/store';

export function isCode(httpResponse: any, action: Action) {
  const { meta, data } = httpResponse;
  const { code } = meta;
  const fragments: string[] = code.split(':');
  const [identifier, name] = fragments;
  if (fragments.length != 2) {
    return false;
  }
  const validNames = [
    action.type,
    action.type.replace('Event', 'DomainEvent').replace('EventEvent', 'Event'),
  ];

  return validNames.includes(name);
}
